import { AudioService } from 'src/app/services/audio/audio.service';
import { Component, OnInit } from "@angular/core";
import { EventsService } from "src/app/services/event/event.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { Navigator } from "../menu/navigator";
import { GameHubControllerService } from 'src/app/services/gameHub/game-hub-controller';
import { AppstorageTsService } from 'src/app/services/appstorage/appstorage.ts.service';
import { DisplayMode, OrientationService } from 'src/app/services/orientation/orientation.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { Platform } from '@ionic/angular';

@Component({
  selector: "app-site-header",
  templateUrl: "./site-header.component.html"
})

export class SiteHeaderComponent implements OnInit {

  protected isAuthenticated: boolean = false;
  protected showDevloperButton: boolean = false;
  protected inGame: boolean = false;

  public isMobileWeb: boolean;
  protected isLoggedIn: boolean = false;
  protected isPlayerFirstVisit: any;
  protected displayMode: DisplayMode;
  public showNotification = false;
  public welcomeDialogConfig: any;
  constructor(
    private readonly events: EventsService,
    private readonly gameHubController: GameHubControllerService,
    private readonly configService: ConfigService,
    private readonly navigator: Navigator,
    private readonly userSessionService: UserSessionService,
    private readonly orientationService: OrientationService,
    private appStorageService: AppstorageTsService,
    private audioService: AudioService,
    private platform: Platform
  ) {

  }

  ngOnInit(): void {
    this.orientationService.displayMode$.subscribe((mode) => {
      this.displayMode = mode;
    });

    this.verifyAuth();

    this.events.subscribe("event:login", () => {
      this.verifyAuth();
    });

    this.events.subscribe("action:changeTab", (tabName) => {
      this.navigator.toTab(tabName, true);
      this.verifyAuth();
    });

    this.events.subscribe("event:authentication:logout", () => {
      this.verifyAuth();
    });

    this.events.subscribe("event:gameLaunched", (res) => {
      this.inGame = true;
    });

    this.events.subscribe("event:game:close", () => {
      this.inGame = false;
    });
    this.events.subscribe("event:notification:show", () => {
      this.showNotification = true;
    })
    this.events.subscribe("event:notification:hide", () => {
      this.showNotification = false;
    })

    this.welcomeDialogConfig = this.configService.getConfig().FEATURE_DELAY_WELCOME_DIALOG ? this.configService.getConfig().FEATURE_DELAY_WELCOME_DIALOG : 3;
    this.isMobileWeb = (!this.platform.is('capacitor') || !this.platform.is('cordova')) && (this.platform.is('mobile') || this.platform.is('mobileweb'));
  }

  public navigateTo(page: string, customModalClass?: string, animated?: boolean) {
    return this.navigator.navigateTo(page, { customModalClass: customModalClass, animated: animated });
  }

  public openSettingsPopover(): any {
    this.audioService.playSound("SettingsOpen")
    return this.navigator.navigateTo("SiteMenuComponent",{ customModalClass: 'crown-modal'});
  }

  private verifyAuth() {
    this.userSessionService.isAuthenticated().then((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
    });

    this.userSessionService.getCustomer().subscribe((customer) => {
      if (customer) {
        this.isAuthenticated = !!customer;
        this.isLoggedIn = true;
      } else {
        this.isLoggedIn = false;
      }
    });

    if (this.isLoggedIn) console.log('Congratulations, You are logged in');
    if (!this.isLoggedIn) console.log('Sorry, You are logged out');
  }

  protected toHome(): any {
    return this.gameHubController.terminateGame();
  }

  async showWelcomeDialog() {
    this.isPlayerFirstVisit = (await this.appStorageService.getPlayerFirstVisit()).value;
    if (this.isPlayerFirstVisit === 'true') {
      this.userSessionService.getCustomer().subscribe((customer) => {
        if (customer) {
          console.log('---show welcome dialog---');
          setTimeout(() => {
            this.events.publish('show:welcome:dialog');
          }, this.welcomeDialogConfig * 1000);
          this.appStorageService.setPlayerFirstVisit(false);
        }
      })
    }
  }

  public openDownloadPage(): any {
    return this.navigator.navigateTo('DownloadAppsComponent', { customModalClass: 'crown-modal' });
  }
}
